/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
	names: {
		signUp: process.env.GATSBY_SSO_SIGN_UP,
		signIn: process.env.GATSBY_SSO_SIGN_IN,
		editRole: 'b2c_1a_profileedit-educator',
		editEmail: 'b2c_1a_profileedit-changeemail',
	},
	authorities: {
		signUp: {
			authority: `${ process.env.GATSBY_SSO_BASE_URL }${ process.env.GATSBY_SSO_SIGN_UP }`,
		},
		signIn: {
			authority: `${ process.env.GATSBY_SSO_BASE_URL }${ process.env.GATSBY_SSO_SIGN_IN }`,
		},
		editRole: {
			authority: `${ process.env.GATSBY_SSO_BASE_URL }b2c_1a_profileedit-educator`,
		},
		editEmail: {
			authority: `${ process.env.GATSBY_SSO_BASE_URL }b2c_1a_profileedit-changeemail`,
		},
	},
	authorityDomain: process.env.GATSBY_SSO_BASE_URL,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
	auth: {
		clientId: process.env.GATSBY_SSO_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
		authority: b2cPolicies.authorities.signIn.authority, // Choose SUSI as your default authority.
		knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
		redirectUri: '/account', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
		postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
		navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
	},
	cache: {
		cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		allowRedirectInIframe: true,
	},
};
